import { isEmpty as _isEmpty } from "lodash";

import ObjectUtil from "../utils/ObjectUtil";

const { isUndefinedOrNull } = ObjectUtil;

export const initGlobalSharedData = () => {
    if (isUndefinedOrNull(globalThis.integratedSharedData)) {
        /*
        integratedSharedData is a shared data object to be used by the PCap team.
        keys on this object should be immutable
        */
        globalThis.integratedSharedData = {};
    }
};

export const setGlobalSharedAuthData = (authData) => {
    const { integratedSharedData } = globalThis;

    if (
        !isUndefinedOrNull(integratedSharedData) &&
        !_isEmpty(integratedSharedData.isInboundSSOUser)
    ) {
        return;
    }
    if (isUndefinedOrNull(authData)) {
        console.warn("No data passed to setGlobalAuthData");
        return;
    }

    globalThis.integratedSharedData.isInboundSSOUser = authData.inboundSSOUser;
};
